import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PageHeader from '../../components/UI/PageHeader';
import Card from '../../components/UI/Card';
import Button from '../../components/UI/Button';

const DeviceCreate: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  
  const handleCancel = () => {
    navigate(`/users/${id}/devices`);
  };
  
  return (
    <div>
      <PageHeader
        title="Add Device"
        breadcrumbs={[
          { label: "Dashboard", to: "/" },
          { label: "Users", to: "/users" },
          { label: "User", to: `/users/${id}` },
          { label: "Devices", to: `/users/${id}/devices` },
          { label: "Add Device" }
        ]}
      />
      
      <Card>
        <div className="text-center py-8">
          <p className="text-gray-500 mb-4">
            Add device functionality is under development for user ID: {id}
          </p>
          <Button
            type="button"
            variant="ghost"
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default DeviceCreate;